"use client";

import { usePathname } from "next/navigation";
import { BackgroundLines } from "@/components/ui/background-lines";

export function ConditionalBackgroundLines() {
  const pathname = usePathname();

  // Don't show background lines on blog detail pages
  const isBlogDetail = pathname.match(/^\/blogs\/[^/]+$/);

  if (isBlogDetail) {
    return null;
  }

  return <BackgroundLines />;
}
